import {NineSlicePlane} from '@fantasmagames/core/src/display/NineSlicePlane';
import {View} from '@fantasmagames/slot/src/common/view/View';
import {GenericButton} from '@fantasmagames/slot/src/modules/popupmenus/GenericButton';
import {Timer} from '@fantasmagames/core/src/update/Timer';

export class InfoPopupView extends View {
	public static readonly OK_CLICKED: string = 'InfoPopupView::OK_CLICKED';
	public static readonly HOME_CLICKED: string = 'InfoPopupView::HOME_CLICKED';

	protected _textStyle: PIXI.TextStyle;

	protected _window9Slice: PIXI.mesh.NineSlicePlane;
	protected _window9SliceError: PIXI.mesh.NineSlicePlane;
	protected _window9SliceRealityCheck: PIXI.mesh.NineSlicePlane;
	protected _okButton: GenericButton;
	protected _okRealityCheckButton: GenericButton;
	protected _homeButton: GenericButton;
	protected _okErrorButton: GenericButton;
	protected _infoText: PIXI.Text;
	protected _infoRealityCheckText: PIXI.Text;
	protected _infoErrorText: PIXI.Text;

	protected _background: PIXI.Graphics;

	protected _disabledTint: number = 0x888888;

	protected _currentSimpleMessageTimer: Timer;

	public init(): void {
		super.init();

		this._background = new PIXI.Graphics();
		this._background.beginFill(0x000000, 0.5);
		this._background.drawRect(0, 0, this.resolutionManager.resolution.width, this.resolutionManager.resolution.height);
		this._background.endFill();

		this._window9Slice = new NineSlicePlane(
			this.resources.getSpritesheetTexture('HUD.json', 'INFO_MESSAGE.png'),
			this.resources.getNineSliceData('HUD.json', 'INFO_MESSAGE.png'),
		);

		this._window9SliceRealityCheck = new NineSlicePlane(
			this.resources.getSpritesheetTexture('HUD.json', 'INFO_MESSAGE.png'),
			this.resources.getNineSliceData('HUD.json', 'INFO_MESSAGE.png'),
		);

		this._window9SliceError = new NineSlicePlane(
			this.resources.getSpritesheetTexture('HUD.json', 'ERROR_MESSAGE.png'),
			this.resources.getNineSliceData('HUD.json', 'ERROR_MESSAGE.png'),
		);

		this._okButton = this.createOKButton();
		this._okRealityCheckButton = this.createOKButton();
		this._okErrorButton = this.createOKButton();
		this._homeButton = this.createHomeButton();

		this._window9Slice.addChild(this._okButton);
		this._window9SliceError.addChild(this._okErrorButton);
		this._window9SliceRealityCheck.addChild(this._okRealityCheckButton);
		this._window9SliceRealityCheck.addChild(this._homeButton);

		this._textStyle = this.textStyles.infoPopup;

		this._infoText = new PIXI.Text('', this._textStyle);
		this._infoRealityCheckText = new PIXI.Text('', this._textStyle);
		this._window9Slice.addChild(this._infoText);
		this._window9SliceRealityCheck.addChild(this._infoRealityCheckText);

		this._infoErrorText = new PIXI.Text('', this._textStyle);
		this._window9SliceError.addChild(this._infoErrorText);

		this.container.interactive = true;

		this.container.on('mousedown', () => {});
		this.container.on('mouseup', () => {});
		this.container.on('mouseover', () => {});
		this.container.on('mouseout', () => {});
		this.container.on('click', () => {});

		this.container.on('tap', () => {});
		this.container.on('touchstart', () => {});
		this.container.on('touchendoutside', () => {});
		this.container.on('touchend', () => {});
	}

	public showFatalErrorMessage(messageText: string): void {
		this._window9SliceError.width = 600;
		this._window9SliceError.x = this.resolutionManager.halfResolution.width - this._window9SliceError.width / 2;

		this._infoErrorText.text = messageText;
		this._window9SliceError.height = 400 + this._infoErrorText.height;
		this._window9SliceError.y = this.resolutionManager.halfResolution.height - this._window9SliceError.height / 2;

		this._infoErrorText.x = this._window9SliceError.width / 2 - this._infoErrorText.getBounds().width / 2;
		this._infoErrorText.y = 110;

		this.container.addChild(this._background);
		this.container.addChild(this._window9SliceError);
	}

	public showErrorMessage(messageText: string): void {
		this._window9SliceError.width = 600;
		this._window9SliceError.x = this.resolutionManager.halfResolution.width - this._window9SliceError.width / 2;

		this._infoErrorText.text = messageText;
		this._window9SliceError.height = 400 + this._infoErrorText.height;
		this._window9SliceError.y = this.resolutionManager.halfResolution.height - this._window9SliceError.height / 2;

		this._okErrorButton.visible = true;
		this._okErrorButton.x = this._window9SliceError.width / 2;
		this._okErrorButton.y = this._window9SliceError.height - 110 - this._okErrorButton.height;

		this._infoErrorText.x = this._window9SliceError.width / 2 - this._infoErrorText.getBounds().width / 2;
		this._infoErrorText.y = 110;

		this.container.addChild(this._background);
		this.container.addChild(this._window9SliceError);
	}

	public showOKMessage(messageText: string): void {
		this._window9Slice.width = 600;
		this._window9Slice.x = this.resolutionManager.halfResolution.width - this._window9Slice.width / 2;

		this._infoText.text = messageText;
		this._window9Slice.height = 400 + this._infoText.height;
		this._window9Slice.y = this.resolutionManager.halfResolution.height - this._window9Slice.height / 2;

		this._okButton.visible = true;
		this._okButton.x = this._window9Slice.width / 2;
		this._okButton.y = this._window9Slice.height - 110 - this._okButton.height;

		this._infoText.x = this._window9Slice.width / 2 - this._infoText.getBounds().width / 2;
		this._infoText.y = 110;

		this.container.addChild(this._background);
		this.container.addChild(this._window9Slice);
	}

	public showRealityCheckWithExitOptionMessage(messageText: string): void {
		this._window9SliceRealityCheck.width = 600;
		this._window9SliceRealityCheck.x = this.resolutionManager.halfResolution.width - this._window9SliceRealityCheck.width / 2;

		this._infoRealityCheckText.text = messageText;
		this._window9SliceRealityCheck.height = 400 + this._infoRealityCheckText.height;
		this._window9SliceRealityCheck.y = this.resolutionManager.halfResolution.height - this._window9SliceRealityCheck.height / 2;

		this._okRealityCheckButton.visible = true;
		this._okRealityCheckButton.x = this._window9SliceRealityCheck.width / 2 - 120;
		this._okRealityCheckButton.y = this._window9SliceRealityCheck.height - 110 - this._okRealityCheckButton.height;

		this._homeButton.visible = true;
		this._homeButton.x = this._window9SliceRealityCheck.width / 2 + 120;
		this._homeButton.y = this._window9SliceRealityCheck.height - 110 - this._homeButton.height;

		this._infoRealityCheckText.x = this._window9SliceRealityCheck.width / 2 - this._infoRealityCheckText.getBounds().width / 2;
		this._infoRealityCheckText.y = 110;

		this.container.addChild(this._background);
		this.container.addChild(this._window9SliceRealityCheck);
	}

	public showSimpleMessage(messageText: string): void {
		this.showOKMessage(messageText);

		this._okButton.visible = false;

		this.container.on('click', this.onContainerClick.bind(this));
		this.container.on('tap', this.onContainerClick.bind(this));

		this._currentSimpleMessageTimer = new Timer(
			() => {
				this.onContainerClick();
			},
			5000,
			true,
		);
		this.updateManager.add(this._currentSimpleMessageTimer);
	}

	protected createOKButton(): GenericButton {
		const okButton: GenericButton = new GenericButton(this.onOkClicked.bind(this));

		const up = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
		const down = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
		const over = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
		const disabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));

		up.anchor.set(0.5, 0.5);
		down.anchor.set(0.5, 0.5);
		over.anchor.set(0.5, 0.5);
		disabled.anchor.set(0.5, 0.5);
		disabled.tint = this.disabledTint;

		okButton.setFrames(up);
		okButton.anchor.set(0.5, 0.5);

		const confirmImage = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'CONFIRM.png'));
		confirmImage.anchor.set(0.5, 0.5);
		up.addChild(confirmImage);

		return okButton;
	}

	protected createHomeButton(): GenericButton {
		const okButton: GenericButton = new GenericButton(this.onHomeClicked.bind(this));

		const up = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
		const down = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
		const over = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
		const disabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));

		up.anchor.set(0.5, 0.5);
		down.anchor.set(0.5, 0.5);
		over.anchor.set(0.5, 0.5);
		disabled.anchor.set(0.5, 0.5);
		disabled.tint = this.disabledTint;

		okButton.setFrames(up);
		okButton.anchor.set(0.5, 0.5);

		const confirmImageUp = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'HOME_BUTTON.png'));
		confirmImageUp.anchor.set(0.5, 0.5);
		up.addChild(confirmImageUp);

		const confirmImageDown = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'HOME_BUTTON_CLICKED.png'));
		confirmImageDown.anchor.set(0.5, 0.5);
		down.addChild(confirmImageDown);

		const confirmImageOver = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'HOME_BUTTON.png'));
		confirmImageOver.anchor.set(0.5, 0.5);
		over.addChild(confirmImageOver);

		return okButton;
	}

	protected onContainerClick(): void {
		this.container.off('click');
		this.container.off('tap');

		this.updateManager.remove(this._currentSimpleMessageTimer);
		this._currentSimpleMessageTimer = null;

		this.onOkClicked();
	}

	protected onOkClicked(): void {
		this.container.removeChild(this._window9Slice);
		this.container.removeChild(this._window9SliceError);
		this.container.removeChild(this._window9SliceRealityCheck);
		this.container.removeChild(this._background);

		this.emit(InfoPopupView.OK_CLICKED);
	}

	protected onHomeClicked(): void {
		this.container.removeChild(this._window9Slice);
		this.container.removeChild(this._window9SliceError);
		this.container.removeChild(this._window9SliceRealityCheck);
		this.container.removeChild(this._background);

		this.emit(InfoPopupView.HOME_CLICKED);
	}

	public set disabledTint(value: number) {
		this._disabledTint = value;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/info/InfoPopupView.ts